import { Player } from '../../types/common';

export interface ChessGame {
  players: Player[];
}

export interface PieceLegend {
  name: string;
  notation: string;
}

export const ChessColor = {
  WHITE: 'plain',
  BLACK: 'charcoal',
} as const;

export type ChessColorType = typeof ChessColor[keyof typeof ChessColor];

export const pieceLegend: PieceLegend[] = [
  { name: 'Pawn', notation: 'p' },
  { name: 'Knight', notation: 'n' },
  { name: 'Bishop', notation: 'b' },
  { name: 'Rook', notation: 'r' },
  { name: 'Queen', notation: 'q' },
  { name: 'King', notation: 'k' },
];

export const getPlayerColor = (game: any, playerId: string | null): string | null => {
  if (!game || !playerId || !game.players) return null;
  const player = game.players.find((p: any) => p.id === playerId);
  return player ? player.color || null : null; // Returns null if the player isn't found.
};

export const graphics: Record<string, string> = {
  'p-white': '/images/chess/5666.png',
  'n-white': '/images/chess/3432.png',
  'b-white': '/images/chess/1951.png',
  'r-white': '/images/chess/2132.png',
  'q-white': '/images/chess/2670.png',
  'k-white': '/images/chess/3787.png',
  'p-black': '/images/chess/4770.png',
  'n-black': '/images/chess/8161.png',
  'b-black': '/images/chess/2116.png',
  'r-black': '/images/chess/1046.png',
  'q-black': '/images/chess/7791.png',
  'k-black': '/images/chess/931.png',
};